/**
 * Single place for translating error text the backend returns (mostly
 * English, from Django/DRF) into the Polish messages shown to users. This
 * isn't i18n - the app has no other language to switch to - it's just
 * backend-error localization, so a flat dictionary + one lookup function
 * covers it.
 */
const API_ERROR_TRANSLATIONS: Record<string, string> = {
	// Login (auth/token/)
	'No active account found with the given credentials': 'Nieprawidłowy adres email lub hasło.',

	// Driver phone number (drivers/)
	'Driver with this phone number already exists for this account.':
		'Kierowca z tym numerem telefonu jest już przypisany do tego konta.',
	'Driver with this phone number exists for a different account.':
		'Kierowca z tym numerem telefonu jest już przypisany do innego konta. Jeśli potrzebujesz pomocy, skontaktuj się z naszym zespołem.',
	'Incorrect phone number.': 'Nieprawidłowy numer telefonu.',

	// Contract termination eligibility (offer/termination/can-terminate/)
	'Termination already in progress.': 'Wypowiedzenie jest już w trakcie realizacji.',
	'Contract has no balance.': 'Brak salda rozliczeniowego dla umowy.',
	'Cannot terminate contract with negative balance.': 'Nie można wypowiedzieć umowy bez uregulowanego salda.',

	// Settings > Bezpieczeństwo password change (auth/password-change/)
	'Current password is incorrect.': 'Obecne hasło jest nieprawidłowe.',
};

/**
 * Looks up a known backend error string and returns its Polish translation,
 * or `fallback` when the message is missing or not recognized. Never
 * returns raw, untranslated backend text.
 */
export const translateApiError = (message: string | null | undefined, fallback: string): string => {
	if (!message) return fallback;
	return API_ERROR_TRANSLATIONS[message] ?? fallback;
};

// Django's UserAttributeSimilarityValidator message is only partially
// localized by the backend - the sentence itself is Polish but the field
// name is substituted in as "użytkownik", e.g. "Hasło jest zbyt podobne do
// użytkownik." This is a fuzzy fix-up (not an exact-match dictionary entry
// like the ones above) that normalizes it into a grammatically correct
// Polish sentence; anything else is passed through unchanged.
const PASSWORD_SIMILAR_TO_USERNAME_PATTERN = /zbyt podobne do użytkownik\.?$/i;

export const normalizePasswordSimilarityError = (message: string): string =>
	PASSWORD_SIMILAR_TO_USERNAME_PATTERN.test(message)
		? 'Hasło jest zbyt podobne do nazwy użytkownika.'
		: message;
